export default __webpack_public_path__ + "static/media/hills_notch_extended.266f6d6f.svg";